<template>
  <div>
    <div class="qz-search-wrap">
      <van-search
          v-model="keywords"
          placeholder="搜索"
          shape="round"
          @search="onSearch"
      >
        <!--        <div slot="action" @click="onSearch(keywords)" style="padding:0 10px">搜索</div>-->
        <div class="search-content-right" slot="right-icon">
          <div class="search-button flex-center" @click="onSearch(keywords)">搜索</div>
        </div>

      </van-search>
      <div class="search-box" v-if="false">
        <div class="search-content flex-between">
          <input type="text">
          <div class="search-content-left flex-start">
            <van-icon name="search"/>
            <div class="search-placeholder">搜索</div>
          </div>
          <div class="search-content-right">
            <div class="search-button flex-center">搜索</div>
          </div>
        </div>
      </div>
    </div>
    <!--<input class="test" autofocus="autofocus" />-->
    <!--        <div v-if="!keywords && history_list.length>0" class="search-default">-->
    <!--            <h3 class="title">搜索历史 <em @click="emptyHistory" style="float: right ; margin-right: 20px">清除</em></h3>-->

    <!--            <div class="cf"></div>-->
    <!--            <ul class="result cf">-->
    <!--                <li v-for="(item,index) in history_list" class="item" :key="index" @click="onSearch(item) ">{{item}}</li>-->
    <!--            </ul>-->
    <!--            <div class="cf"></div>-->
    <!--        </div>-->
    <!--        <div class="" v-if="emptyShow">-->
    <!--            <van-empty style="margin: 10px auto" description="暂无结果" />-->
    <!--        </div>-->
    <!--        <div v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}" >-->
    <!--            &lt;!&ndash; 无图 style==1 &ndash;&gt;-->
    <!--            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>-->
    <!--            &lt;!&ndash; 有图 style==2 &ndash;&gt;-->
    <!--            <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>-->
    <!--            &lt;!&ndash; 视频 style==3 &ndash;&gt;-->
    <!--            <NewsItem3 v-if="false"></NewsItem3>-->
    <!--            &lt;!&ndash; 多图 style==4 &ndash;&gt;-->
    <!--            <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>-->
    <!--        </div>-->
    <div class="search-button-box flex-start">
            <div class="search-button-left">
              <img  v-rblink="{name:'NewsList',query:{cate_id:71}}"   src="../../../assets/images/cha/bg-xiazaizhongxin.png" />
            </div>
            <div class="search-button-right">
              <img  v-rblink="{name:'ChaSearchPerson',query:{}}"   src="../../../assets/images/cha/bg-gerenchaxun.png" />
              <img  v-rblink="{name:'ChaSearchCaipan',query:{}}"   src="../../../assets/images/cha/bg-caipanyuanchaxun.png" />
            </div>
            <div class="search-button-right">
              <img  v-rblink="{name:'ChaSearchDanwei',query:{}}"   src="../../../assets/images/cha/bg-danweichaxun.png" />
              <img  v-rblink="{name:'ChaSearchJiaolian',query:{}}"   src="../../../assets/images/cha/bg-jiaolianyuanchaxun.png" />
            </div> 
          </div>
    <div class="row4 flex-start" v-if="false">
      <div class="row4-li">
        <img @click="toSearch('sai')"
             src="../../../assets/images/cha/icon-saishihuoodng.png"/>
        <div class="row-tip">赛事活动</div>
      </div>
      <div class="row4-li">
        <img @click="toSearch('news')"
             src="../../../assets/images/cha/icon-xinwenzixun.png"/>
        <div class="row-tip">新闻资讯</div>
      </div>
      <div class="row4-li">
        <img @click="toSearch('huiyi')"
             src="../../../assets/images/cha/icon-peixunhuiyi.png"/>
        <div class="row-tip">培训会议</div>
      </div>
      <div class="row4-li">
        <img @click="toSearch('qcxj')"
             src="../../../assets/images/cha/icon-qicaixingji.png"/>
        <div class="row-tip">七彩星级</div>
      </div>
    </div>

    <div class="row4 flex-start" v-if="false">
      <div class="row4-li">
        <img @click="toSearch('hyjy')"
             src="../../../assets/images/cha/icon-hangyejingying.png"/>
        <div class="row-tip">行业精英</div>
      </div>
      <div class="row4-li">
        <img @click="toSearch('goods')"
             src="../../../assets/images/cha/icon-jifenshangcheng.png"/>
        <div class="row-tip">积分商城</div>
      </div>
      <div class="row4-li">
        <img @click="toSearch('jwjl')"
             src="../../../assets/images/cha/icon-jingwaijiaooliu.png"/>
        <div class="row-tip">境外交流</div>
      </div>
      <div class="row4-li"></div>
    </div>

    <div class="recommend-box">
      <div class="main-bottom-box">
        <!-- <saiItem v-for="(sai,index) in pageListRow.sai" :row="sai"></saiItem> -->
        <!-- <goodsItem v-for="(goods,index) in pageListRow.goods" :row="goods"> -->
        <!-- </goodsItem> -->

          <div v-for="(row,i) in pageListRow.news" :key="i" @click="goDetail(row)">
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>
            <!-- 有图 style==2 -->
            <!-- <NewsItem2 :row="row" v-if="row.pics.length>0"></NewsItem2>  -->
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length>0"></NewsItem4>
          </div> 
        <!-- <peiItem v-for="(huiyi,index) in pageListRow.huiyi" :row="huiyi"></peiItem> -->
 
          </div>
      </div>
    </div>

  </div>
</template>
<style scoped> 
  .search-button-box {
  margin: .2rem;
}

.search-button-left img {
  width: 1.86rem;
  margin-right: .2rem;
}

.search-button-right img {
  margin-bottom: .1rem;
  margin-right: .2rem;
  width: 2.42rem;
}
    .box {
        background: #f8f8f8;
        padding-bottom: 50px;
        overflow: hidden;
    }
    .row1{
        /*padding: 10px;*/
        margin: 0 10px;
    }
    .row1 img{
        width: 100%;
        margin: 10px 0 0 0 ;
    }
    .row3{
        /*display: flex;*/
        /*align-items: center;*/
        /*justify-content: space-between;*/
        margin: 10px 10px;
        /*flex-wrap: wrap;*/
    }
    .row3 img{
        float: left;
        width: calc(33.33% - 10px);
        margin: 0 10px 10px 0;
    }
    .logo-ul{
        background: #fff;
        border-radius: 10px;
        height: 100px;
        margin: 0 10px;
    }
    .logo-ul div{
        text-align: center;
        float: left;
        width: calc(33.33% - 10px);
        margin: 0 0 10px 10px;
        line-height: 110px;
        height: 110px;
    }
    .logo-ul img{
        width: 100%;
        display: inline-block;
    }


    .placeholder {
        font-size: 28rpx;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(186, 186, 186, 1);
    }
    .search {
        width: 7rem;
        height: 1.0rem;
        background: rgba(239, 239, 244, 1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin: 10px auto;
    }
    .search img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.2rem;
    }

.qz-search-wrap .van-search {
  padding: .3rem .2rem;
}

.qz-search-wrap .van-search__content {
  border: 1px solid #FA6400;
  background: #fff;
  color: #C8C9CC;
}
.qz-search-wrap >>> .van-icon {
  color: #C8C9CC;
}

.qz-search-wrap .van-cell {
  padding: 2px 8px 2px 0;
  line-height: 30px;
}

.qz-search-wrap >>> .van-field__body input::-webkit-input-placeholder {
  color: #C8C9CC;
}

.qz-search-wrap >>> .van-field__right-icon {
  padding: 0 2px;
}

.qz-search-wrap .search-content-right {
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
}

.qz-search-wrap .search-content-right .search-button {
  background: linear-gradient(133deg, #FD9D00 0%, #FA6400 100%);
  border-radius: 50px;
  width: 52px;
  height: 30px;
}

.recommend-box {
  width: 100%;
  height: 192px;
  background: url('../../../assets/images/cha/bg-neirongtuijian.png') no-repeat center;
  background-size: 100%;
  position: relative;
  margin-top: .3rem;
}

.main-bottom-box {
  display: flex;
  justify-content: space-between;
  width: 7.1rem;
  margin: 0 auto;
  flex-wrap: wrap;
  padding-top: 50px;
}

.row4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: .2rem;
}

.row4 img {
  /*width: 100%;*/
  width: 34px;
  height: 34px;
}

.row-tip {
  font-size: .2rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.row4-li {
  width: calc(25%);
  text-align: center;
}

.search-default {
  background-color: #fff;
}

.search-default .title {
  line-height: 38px;
  padding-left: 13px;
  font-size: 14px;
  color: #999;
  font-weight: normal;
}

.search-default .result {
}

.search-default .result .item {
  box-sizing: border-box;
  width: 50%;
  line-height: 36px;
  float: left;
  padding-left: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #666;
}

.cf {
  clear: both;
}

.equalblock-warp {
  width: 100%;
  display: flex;
  font-size: 0;
}

.equalblock-item {
  flex: 1;
}

.equalblock-pic {
  width: 100%;
  min-height: 30px;
}

span.s {
  width: 1px;
  background: rebeccapurple;
}

.equalblock-item .equalblock-title {
  font-size: 14px;
  display: inline-block;
  width: 100%;
  text-align: center;
  padding: 5px 0;
}
</style>

<script>
import {
  Search,
  Cell, CellGroup, Field, Button, Empty, Toast
} from 'vant';
import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import saiItem from "@/components/index/SaiItem.vue";
import goodsItem from "@/components/index/GoodsItem.vue";
import newsItem from "@/components/index/NewsItem.vue";
import peiItem from "@/components/index/PeiItem.vue";
//    import $ from  'jquery';
export default {
  name: 'goodsSearch',
  components: {
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Empty.name]: Empty,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    saiItem,
    goodsItem,
    newsItem,
    peiItem
  },
  data: function () {
    return {
      keywords: '',
      hot_list: [],
      list: [],
      emptyShow: false,
      history_list: [],

      pageListRow: {
        sai: [],
        huiyi: [],
        news: [],
        goods: [],
      },
    }
  },
  watch: {
    keywords(value) {
      if (!value) {
        return false;
      }
//                this.load();
    }
  },
  filter: {},
  created() {
    document.title = "查询";
    let that = this;
    that.history_list = JSON.parse(localStorage.getItem('search_history') || '[]');
//            alert($('body').height())
    that.fetch()
  },
  mounted() {
    setTimeout(() => {
//                console.log('开始聚焦');
//                alert('开始聚焦');
//            $('.van-search__content input').focus();
//            $('.van-search__content input').click();
//            $('.test').focus();
    }, 100);
//            $('.van-search__content input').click(function(){
//                alert('开始聚焦');
//                $('.van-search__content input').focus();
//            })
  },
  methods: {
    goDetail(row){
      rbLink({name:'NewsDetail',query:{id:row.id }})
    },
    fetch() {
      let that = this;
      this.$api.get('/api/index/appIndexData', {}, (res => {
            that.pageListRow = res.data.pageList
            let arr = []
            res.data.pageList.huiyi.map((item, i) => {
              arr = arr.concat(item)
            })
            that.pageListRow.huiyi = arr

          })
      )

    },

    toSearch(sign) {
      rbLink({
        name: "ChaSearchAllResult",
        query: {
          sign: sign,
        }
      })
    },

    onSearch(val) {
      console.log(val);
      val = (val + '').trim();

      if(!val) {
        Toast('请输入关键词')
        return
      }

      this.keywords = val;
      let search_history = JSON.parse(localStorage.getItem('search_history') || '[]');
      if (search_history.indexOf(val) == -1) {
        search_history.push(val);
        localStorage.setItem('search_history', JSON.stringify(search_history));
        this.history_list = search_history;
      }
      // this.load();

      rbLink({
        name: "ChaSearchAllResult",
        query: {
          keywords: this.keywords,
        }
      })
    },
    emptyHistory() {
      this.history_list = [];
      localStorage.setItem('search_history', '[]');
    },
    load() {
      let that = this;
      this.$api.get(
          "/api/cms/cmslist", {
            keywords: that.keywords
          }, r => {
            that.list = r.data.list;
            if (r.data.list.length == 0) {
              that.emptyShow = true;
            } else {
              that.emptyShow = false;
            }
          });
    }
  }
}
</script>



// WEBPACK FOOTER //
// SearchAll.vue?5e9ef5b7